import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { DeployUrlPipe } from '@innogy/utils/environment';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import { MasonryContentItemModel } from '../masonry-content-item.model';

@Component({
  selector: 'wl-masonry-card',
  templateUrl: './masonry-card.component.html',
  styleUrls: [
    './masonry-card.component.essent.scss',
    './masonry-card.component.ed.scss',
  ],
  standalone: true,
  imports: [
    AutomationIdDirective,
    RouterLink,
    LazyLoadImageModule,
    DeployUrlPipe,
  ],
})
export class MasonryCardComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() item?: MasonryContentItemModel;
}
